import React from "react";
import { Button, Modal } from 'react-bootstrap';
import styles from '../../../../styles/FarmGlobal/TesteDeBase.module.scss';
import { useFGTesteDeBase } from "../../../../contexts/FarmGlobal/TesteDeBaseContext.js";

const ModalConfirmacaoNovaFicha = () => {

    const { showConfirmacaoNovaFicha, setShowConfirmacaoNovaFicha, materialAtivo, handleSaveUpdateMaterial} = useFGTesteDeBase();
    
    const handleSubmit = (status) => {
        handleSaveUpdateMaterial(status);
    };


    return (
        <Modal
            show={showConfirmacaoNovaFicha}
            onHide={()=> { setShowConfirmacaoNovaFicha(false);}}
            backdrop="static"
            keyboard={false}
            centered
        >
        <Modal.Header>
            <Modal.Title>Confirmação de Nova Ficha</Modal.Title>
        </Modal.Header>
        <Modal.Body  style={{textAlign:'center'}}>
            <span>              
                Tem certeza que deseja inserir a nova ficha  <br/><strong>{materialAtivo?.Descricao}</strong>?                
            </span>
        </Modal.Body>
        <Modal.Footer className={styles.modalFooter}>
            <Button
                    variant="success"
                    className={styles.modalBtn}
                    onClick={() => handleSubmit('nova-ficha')}
                >
                    Sim
                </Button>
                <Button
                    variant="outline-danger"
                    className={styles.modalBtn}
                    onClick={()=> { setShowConfirmacaoNovaFicha(false);}}
                >
                    Voltar
                </Button>
        </Modal.Footer>
      </Modal>
    ) 
}

export default ModalConfirmacaoNovaFicha;
